export const POS_TYPES = {
  RETAIL: "Retail POS",
  CONVENIENCE_STORE: "Convenience Store POS",
  RESTAURANT: "Restaurant POS",
  CAFE: "Cafe POS",
  GROCERY: "Grocery POS",
  PHARMACY: "Pharmacy POS",
  SALON_SPA: "Salon/Spa POS",
  SERVICE: "Service POS",
  GENERAL: "General POS",
};

export const POS_TYPE_OPTIONS = [
  POS_TYPES.RETAIL,
  POS_TYPES.CONVENIENCE_STORE,
  POS_TYPES.RESTAURANT,
  POS_TYPES.CAFE,
  POS_TYPES.GROCERY,
  POS_TYPES.PHARMACY,
  POS_TYPES.SALON_SPA,
  POS_TYPES.SERVICE,
  POS_TYPES.GENERAL,
];

export const normalizePosType = (value) => {
  if (!value || value === "Point of Sales") return POS_TYPES.RETAIL;
  return value;
};

export const getEnabledModulesForPosType = (posType) => {
  const normalizedType = normalizePosType(posType);
  const commonModules = ["sales", "transactions", "expenses", "products"];

  if (normalizedType === POS_TYPES.RESTAURANT || normalizedType === POS_TYPES.CAFE) {
    return [...commonModules, "kitchenOrders", "tables"];
  }

  return commonModules;
};
